import bgUrl from "./art/bg.png";
import idleUrl from "./art/butelkomat-idle.png";
import acceptUrl from "./art/butelkomat-accept.png";
import petUrl from "./art/bottle-pet.png";
import pet2Url from "./art/bottle-pet-2.png";
import pet3Url from "./art/bottle-pet-3.png";
import canUrl from "./art/bottle-can.png";
import can2Url from "./art/bottle-can-2.png";
import can3Url from "./art/bottle-can-3.png";
import glassUrl from "./art/bottle-glass.png";
import glass2Url from "./art/bottle-glass-2.png";
import glass3Url from "./art/bottle-glass-3.png";
import crushedUrl from "./art/bottle-crushed.png";
import menelUrl from "./art/menel.png";
import policeUrl from "./art/police.png";
import sackUrl from "./art/bag.png";
import skupBagUrl from "./art/skup-bag.png";

export const SKUP_BAG_URL = skupBagUrl;

export const BOTTLE_ART_URLS = {
  bg: bgUrl,
  idle: idleUrl,
  accept: acceptUrl,
  pet: petUrl,
  pet2: pet2Url,
  pet3: pet3Url,
  can: canUrl,
  can2: can2Url,
  can3: can3Url,
  glass: glassUrl,
  glass2: glass2Url,
  glass3: glass3Url,
  crushed: crushedUrl,
  menel: menelUrl,
  police: policeUrl,
  sack: sackUrl,
} as const;

export type BottleArtKey = keyof typeof BOTTLE_ART_URLS;
export type BottleArtMap = Partial<Record<BottleArtKey, HTMLImageElement | null>>;
